import './FormGroup.scss';

import { type ReactNode, type ReactElement, type FC, useMemo } from 'react';
import { uniqueId } from 'lodash-es';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

interface Props {
  label?: ReactNode;
  required?: boolean;
  inline?: boolean;
  errorMessage?: ReactNode;
  children?: ReactElement | ((props: { inputID: string }) => ReactElement);
  hint?: string;
}

const FormGroup: FC<Props> = (props) => {
  const {
    label,
    required = false,
    inline = false,
    errorMessage,
    children,
    hint,
  } = props;
  const { t } = useTranslation();

  const inputID = useMemo(() => uniqueId('input'), []);

  return (
    <div
      className={classNames('FormGroup', {
        'FormGroup--inline': inline,
        'is-invalid': errorMessage != null,
      })}
    >
      <label className="FormGroup-label" htmlFor={inputID}>
        {label}
        &nbsp;
        {required || `(${t('forms.optional')})`}
      </label>

      {typeof children === 'function' ? children({ inputID }) : children}

      {hint != null && <div className="FormGroup-hint">{hint}</div>}

      {errorMessage != null && (
        <div className="FormGroup-error">{errorMessage}</div>
      )}
    </div>
  );
};

export default FormGroup;
